var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test p-5"},[_c('DashboardDatePicker')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }